import { Images } from './images';
import { cfgToThemeCdnPath } from '@infinitro/config';
import { push } from 'svelte-spa-router';
const handleClick = async (e, url) => {
    if (e)
        e.preventDefault();
    if (url === 'login') {
        console.log('not authed');
    }
    else {
        push(url);
    }
};
export const banners = [
    {
        desktopImage: {
            en: Images.Banner1
        },
        mobileImage: {
            en: Images.Banner1
        },
        onClick: (e) => handleClick(e, '/calendar'),
        path: '/calendar',
        startsOn: Date.UTC(2024, 4 - 1, 1), // 2024-04-01 0:00 UTC
        endsOn: Date.UTC(2025, 5 - 1, 2) // 2024-05-02 10:00 UTC
    },
    {
        desktopImage: {
            en: Images.Banner2
        },
        mobileImage: {
            en: Images.Banner2
        },
        onClick: (e) => handleClick(e, '/calendar'),
        path: '/calendar',
        startsOn: Date.UTC(2024, 4 - 1, 1), // 2024-04-01 0:00 UTC
        endsOn: Date.UTC(2025, 5 - 1, 2) // 2024-05-02 10:00 UTC
    },
    {
        desktopImage: {
            en: Images.Banner3
        },
        mobileImage: {
            en: Images.Banner3
        },
        onClick: (e) => handleClick(e, '/calendar'),
        path: '/calendar',
        startsOn: Date.UTC(2024, 4 - 1, 1), // 2024-04-01 0:00 UTC
        endsOn: Date.UTC(2025, 5 - 1, 2) // 2024-05-02 10:00 UTC
    },
    {
        desktopImage: {
            en: Images.Banner1
        },
        mobileImage: {
            en: Images.Banner1
        },
        onClick: (e) => handleClick(e, '/calendar'),
        path: '/calendar',
        startsOn: Date.UTC(2024, 4 - 1, 1), // 2024-04-01 0:00 UTC
        endsOn: Date.UTC(2025, 5 - 1, 2) // 2024-05-02 10:00 UTC
    },
    {
        desktopImage: {
            en: Images.Banner2
        },
        mobileImage: {
            en: Images.Banner2
        },
        onClick: (e) => handleClick(e, '/calendar'),
        path: '/calendar',
        startsOn: Date.UTC(2024, 4 - 1, 1), // 2024-04-01 0:00 UTC
        endsOn: Date.UTC(2025, 5 - 1, 2) // 2024-05-02 10:00 UTC
    },
    {
        desktopImage: {
            en: Images.Banner3
        },
        mobileImage: {
            en: Images.Banner3
        },
        onClick: (e) => handleClick(e, '/calendar'),
        path: '/calendar',
        startsOn: Date.UTC(2024, 4 - 1, 1), // 2024-04-01 0:00 UTC
        endsOn: Date.UTC(2025, 5 - 1, 2) // 2024-05-02 10:00 UTC
    }
];
export const banerFixedData = [
    {
        imgPath: cfgToThemeCdnPath('/banner-swiper/banner001-d.png'),
        title: `running<br/>sushi`,
        subTitle: `ONLY ON LUNA`,
        subBgColor: 'var(--component-banner-swiper-banner-fixed-regular-color)',
        subTextColor: 'var(--component-banner-swiper-banner-fixed-text-dark)',
        actionName: 'Play Now',
        actionUrl: '/'
    },
    {
        imgPath: cfgToThemeCdnPath('/banner-swiper/banner002-d.png'),
        title: `FURY<br/>OF ODIN`,
        subTitle: `HUGE JACKPOT`,
        subBgColor: 'var(--component-banner-swiper-banner-fixed-sub01-bg)',
        subTextColor: 'var(--component-banner-swiper-banner-fixed-text-light)',
        actionName: 'Try your luck',
        actionUrl: '/'
    },
    {
        imgPath: cfgToThemeCdnPath('/banner-swiper/banner003-d.png'),
        title: `BOOK OF<br/>GOLDEN SANDS`,
        subTitle: `PROMOTED GAME`,
        subBgColor: 'var(--component-banner-swiper-banner-fixed-sub02-bg)',
        subTextColor: 'var(--component-banner-swiper-banner-fixed-text-light)',
        actionName: 'Play Now',
        actionUrl: '/'
    }
];
